import type { ReactNode } from 'react'
import { useCurrentUser } from '~/features/app-hooks'
import { AnnotationsProvider } from '~/st-doc-viewer/annotations-context'
import { useProcess, useSelect } from '~/store'
import {
  selActiveCrossReferenceNavigationState,
  selFolderUsers,
  selViewerStampAnnotations
} from './st-folder-selectors'

export function STAnnotationsProvider({ children }: { children: ReactNode }) {
  const currentUser = useCurrentUser()
  const users = useSelect('stFolder', selFolderUsers)
  const stampAnnotations = useSelect('stFolder', selViewerStampAnnotations)
  const navigation = useSelect('stFolder', selActiveCrossReferenceNavigationState)
  const process = useProcess('stFolder')
  const previous = navigation?.prev
  const next = navigation?.next

  return (
    <AnnotationsProvider
      currentUser={currentUser}
      users={users}
      stampAnnotations={stampAnnotations}
      crossReferenceNavigation={{
        previous:
          previous && (() => process.send({ type: 'navigationRequested', request: previous })),
        next: next && (() => process.send({ type: 'navigationRequested', request: next }))
      }}
    >
      {children}
    </AnnotationsProvider>
  )
}
